import React from 'react';

import { withGoogleAnalyticsClickEvent, GoogleAnalyticsConstants } from '@vvoyages/google-analytics';

const ExternalLink = ({
  href,
  className,
  name,
  onClick,
}: {
  href: string;
  className?: string;
  name: string;
  onClick?: () => {};
}) => (
  <a href={href} className={className} rel="noopener noreferrer" target="_blank" onClick={onClick}>
    {name}
  </a>
);

export default withGoogleAnalyticsClickEvent(
  ExternalLink,
  () => GoogleAnalyticsConstants.EVENT_ACTION.LINK_CLICK,
  (props: { name: string }) => props.name,
);
